import React, { useEffect, useState } from "react";
import { Collapse, Spin, Timeline } from "antd";
import { getRoutingHistory } from "../../API/api";


export default function RoutingHistory({ questionId }) {
 const [routingData, setData] = useState({});
 const [isLoading, setLoading] = useState(false);
 const showRoutingHistoryDate = (start, end) => {
   if (end === null) {
     let newDate = `${
       new Date(start).getMonth() + 1 > 9
         ? new Date(start).getMonth() + 1
         : new Date(start).getMonth() + 1
     }-${new Date(start).getDate()}-${new Date(start).getFullYear()}`;
     return `${newDate} ${
       new Date(start).getHours().toString().length > 1
         ? new Date(start).getHours()
         : "0" + new Date(start).getHours()
     }:${
       new Date(start).getMinutes().toString().length > 1
         ? new Date(start).getMinutes()
         : "0" + new Date(start).getMinutes()
     }`;
   } else {
     let newDate = `${
       new Date(start).getMonth() + 1 > 9
         ? new Date(start).getMonth() + 1
         : new Date(start).getMonth() + 1
     }-${new Date(start).getDate()}-${new Date(start).getFullYear()}`;
     let newDate2 = `${
       new Date(end).getMonth() + 1 > 9
         ? new Date(end).getMonth() + 1
         : new Date(end).getMonth() + 1
     }-${new Date(end).getDate()}-${new Date(end).getFullYear()}`;
     return `${newDate} ${
       new Date(start).getHours().toString().length > 1
         ? new Date(start).getHours()
         : "0" + new Date(start).getHours()
     }:${
       new Date(start).getMinutes().toString().length > 1
         ? new Date(start).getMinutes()
         : "0" + new Date(start).getMinutes()
     } - ${newDate2} ${
       new Date(end).getHours().toString().length > 1
         ? new Date(end).getHours()
         : "0" + new Date(end).getHours()
     }:${
       new Date(end).getMinutes().toString().length > 1
         ? new Date(end).getMinutes()
         : "0" + new Date(end).getMinutes()
     }`;
   }
 };
 const formatData = (arr) => {
   let newData =
     arr.length === 0
       ? arr
       : arr.filter((obj) => {
           obj.color =
             obj.status === "answered"
               ? "green"
               : obj.status === "open"
               ? "blue"
               : obj.status === "rerouted"
               ? "orange"
               : obj.status === "expired"
               ? "red"
               : obj.status === "rejected"
               ? "brown"
               : "grey";
           obj.children = `${obj.name} (${obj.status.replace(
             /(^\w|\s\w)/g,
             (m) => m.toUpperCase()
           )}) ${showRoutingHistoryDate(obj.createdDate, obj.modifiedDate)}`;
           obj.style = {
             "font-size": "14px",
             fontWeight: "300",
             color: `${obj.status === "answered" && "green"}`,
           };
           return obj;
         });
   return newData;
 };
 const fetchRoutingHistory = () => {
   setLoading(true);
   getRoutingHistory(atob(questionId)).then(res=>{
     if (res===undefined) return;
     if(res?.data?.success){
       setLoading(false);
       setData(res?.data?.data);
     }
   });
 };
 useEffect(() => {
   fetchRoutingHistory();
 }, []);
 return (
   <div className="mt-3">
     <div style={{ textAlign: "center" }}>
       <span style={{ fontSize: "22px", color: "#2A364A", fontWeight: "400", }}>Routing History</span>
     </div>
     <Spin spinning={isLoading}>
       <div className="mt-3">
         {routingData["country"] && (
           <Collapse
             style={{
               background: "#fff",
               fontSize: "15px",
               borderColor: "#F0F0F0",
               fontWeight: "300",
               color: "#2A364A"
             }}
             className="mb-1"
             items={[
               {
                 key: "1",
                 label: "Country Level",
                 children: (
                   <Timeline items={formatData(routingData["country"])} />
                 ),
               },
             ]}
           />
         )}
         {routingData["region"] && (
           <Collapse
             style={{
               background: "#fff",
               fontSize: "15px",
               borderColor: "#F0F0F0",
               fontWeight: "300",
               color: "#2A364A"
             }}
             className="mb-1"
             items={[
               {
                 key: "1",
                 label: "Region Level",
                 children: (
                   <Timeline items={formatData(routingData["region"])} />
                 ),
               },
             ]}
           />
         )}
         {routingData["global"] && (
           <Collapse
             style={{
               background: "#fff",
               fontSize: "15px",
               borderColor: "#F0F0F0",
               fontWeight: "300",
               color: "#2A364A"
             }}


             className="mb-1"
             items={[
               {
                 key: "1",
                 label: "Global Level",
                 children: (
                   <Timeline items={formatData(routingData["global"])} />
                 ),
               },
             ]}
           />
         )}
         {routingData["empty"] && (
           <Collapse
             style={{
               background: "#fff",
               fontSize: "15px",
               borderColor: "#F0F0F0",
               fontWeight: "300",
               color: "#2A364A"
             }}
             className="mb-1"
             items={[
               {
                 key: "1",
                 label: "Empty Level",
                 children: (
                   <Timeline items={formatData(routingData["empty"])} />
                 ),
               },
             ]}
           />
         )}
       </div>
     </Spin>
   </div>
 );
}
